// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"31165ad9","100":"a2703c0d","384":"8837a1a3","453":"7390bbd6","577":"07865b3c","744":"49fa0c8f","786":"2150819a","849":"c857c0a7","930":"6b3ab9a6","971":"8ad5cc12"}[chunkId] + ".chunk.js";
};